module.exports = __webpack_public_path__ + "img/hero-bg.e7d42e62.png";